// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".region-schools__container--preview[data-v-8be3335a]{-webkit-mask-image:linear-gradient(180deg,#000 70%,transparent);mask-image:linear-gradient(180deg,#000 70%,transparent);-webkit-mask-origin:fill-box;mask-origin:fill-box;max-height:350px;overflow:hidden}.school-card.cursor-pointer[data-v-8be3335a]{transition:box-shadow .2s}.school-card.cursor-pointer[data-v-8be3335a]:hover{box-shadow:0 7.5px 20px 0 rgba(0,41,94,.15)!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
